import "../styles/Recommendations.css"

function RecommendationCard({ food, index }) {
  const numberEmojis = ["1️⃣", "2️⃣", "3️⃣", "4️⃣", "5️⃣"]

  return (
    <div className="recommendation-card">
      <div className="card-header">
        <span className="number-emoji">{numberEmojis[index] || `${index + 1}️⃣`}</span>
        <h3>{food.name}</h3>
      </div>

      <div className="card-content">
        <div className="ingredients">
          <h4>Key Ingredients:</h4>
          <p>{food.ingredients}</p>
        </div>

        <div className="benefits">
          <h4>Why It's Good:</h4>
          <p>{food.benefits}</p>
        </div>

        {food.feedingGuide && (
          <div className="feeding-guide">
            <h4>Feeding Guide:</h4>
            <p>{food.feedingGuide}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default RecommendationCard

